export default __webpack_public_path__ + "static/media/avatar.654b5ec5.png";